import { render, staticRenderFns } from "./PFApp.vue?vue&type=template&id=4eebafda&scoped=true"
import script from "./PFApp.vue?vue&type=script&lang=js"
export * from "./PFApp.vue?vue&type=script&lang=js"
import style0 from "./PFApp.vue?vue&type=style&index=0&id=4eebafda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eebafda",
  null
  
)

export default component.exports